module.exports = __webpack_public_path__ + "img/get-started.755ccfc5.png";